import { type EidCategories } from '@app/client';
import { type WalletAddressData } from '@app/store/types/partner-integrations';

export const getAddressData = (insertTags: EidCategories[], types) => {
    const addressData: WalletAddressData[] = [];
    const separator = '|';

    // we should only be getting one address for now but just in case
    insertTags.forEach((record) => {
        let walletTypeName = '';

        const tag = Object.values(record)[0];
        const data = Object.values(record)[1] as unknown as string;
        const walletAddressInfo =
            insertTags.length === 1 ? data.split(separator) : data.includes(separator) ? data.split(separator) : null;

        const category =
            types && Object.keys(types).find((t) => '0x' + (+t).toString(16).padStart(4, '0') == tag.toString());

        if (category) {
            walletTypeName = types[category].replace('CRYPTO:', '');
        }

        if (walletAddressInfo?.length) {
            addressData.push({
                address: walletAddressInfo[0],
                name: walletAddressInfo[1],
                type: walletTypeName,
            });
        }
    });

    return addressData;
};
